import { BidStateType } from 'hooks/auction/index'
import { AuctionByArtworkQuery, GetEventAuctionByIdQuery, UserOffersQuery } from 'gql'
import { convertServerDateToTz } from '~utils/time-new'
import CurrentBid, { returnBidStatus } from './current-bid'
import getUserBiddingStatusOnArtwork from '../bid-helpers'
import Placeholder from '../common/placeholder'

interface CurrentBidContainerProps {
  userData: UserOffersQuery
  artworkNode: GetEventAuctionByIdQuery['findArtwork']
  auction: AuctionByArtworkQuery['auction']
  pusherData?: BidStateType
  loading: boolean
}

const CurrentBidContainer: React.FC<CurrentBidContainerProps> = ({
  userData,
  artworkNode,
  auction,
  pusherData,
  loading,
}) => {
  if (loading) {
    return <Placeholder />
  }

  const start = auction?.startDate
  const end = auction?.endDate
  const initialBid = auction?.startingBid
  const currentBid = pusherData.bid || auction?.currentBid
  const nextBid = pusherData.nextBid || auction?.nextBid
  const purchaseStatus = auction?.purchaseStatus

  const { isUserHighestBidder, isUserOutbid, isEnd, userWon, winningBid, willStart, userHasPaid } =
    getUserBiddingStatusOnArtwork({
      allOffers: userData?.currentUser?.offers?.edges,
      currentBid,
      start,
      end,
      purchaseStatus,
    })

  return (
    <CurrentBid
      bidValue={(userWon ? winningBid : currentBid) || 0}
      // it's rare, but can be different from currentBid
      // show winningBid for user if they were marked as winner in admin panel
      startsAt={convertServerDateToTz(start, artworkNode.venue.timeZone)}
      endsAt={convertServerDateToTz(end, artworkNode.venue.timeZone)}
      nextMinimalBidValue={nextBid || initialBid}
      bidState={returnBidStatus({
        willStart,
        userWon,
        userPaid: userHasPaid,
        isEnded: isEnd,
        isUserHighestBidder,
        isUserOutbid,
      })}
    />
  )
}

export default CurrentBidContainer
